import React from "react";
import { Navigate } from "react-router";
import { useToken } from "./useToken";
import { useSelector } from "react-redux";

/**
 * AdminRoute — Composant de protection de route réservée aux administrateurs.
 * Analogue à ProtectedRoute, mais vérifie en plus que me.profil contient 'ADMIN'.
 *
 * - Si non authentifié → redirige vers /login
 * - Si authentifié mais non-admin → redirige vers redirectTo (défaut: /billeterie/portefeuil)
 * - Si admin → affiche le composant enfant
 */
const AdminRoute = ({ children, redirectTo = "/billeterie/portefeuil" }) => {
    const [token] = useToken();
    const { me } = useSelector((state) => state.me);

    if (!token) {
        return <Navigate to="/login" />;
    }

    if (!me?.profil?.includes('ADMIN')) {
        return <Navigate to={redirectTo} />;
    }

    return children;
};

export default AdminRoute;
